import { StyleSheet } from 'react-native';
import { Box, Text } from '../../../components/primitives';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';
import { CampaignStatus } from '../types';

const STATUS_COLORS: Record<CampaignStatus, { bg: string; text: string }> = {
  [CampaignStatus.DRAFT]: {
    bg: colors.background.tertiary,
    text: colors.text.tertiary,
  },
  [CampaignStatus.ACTIVE]: {
    bg: colors.status.success.bg,
    text: colors.status.success.main,
  },
  [CampaignStatus.COMPLETED]: {
    bg: colors.primary.muted,
    text: colors.primary[400],
  },
};

interface CampaignStatusBadgeProps {
  status: CampaignStatus;
}

export function CampaignStatusBadge({ status }: Readonly<CampaignStatusBadgeProps>) {
  const { t } = useTranslation();
  const colorSet = STATUS_COLORS[status];

  const labelMap: Record<CampaignStatus, string> = {
    [CampaignStatus.DRAFT]: t('campaigns.status.draft'),
    [CampaignStatus.ACTIVE]: t('campaigns.status.active'),
    [CampaignStatus.COMPLETED]: t('campaigns.status.completed'),
  };

  return (
    <Box style={[styles.badge, { backgroundColor: colorSet.bg }]} borderRadius="full">
      <Text variant="caption" style={[styles.label, { color: colorSet.text }]}>
        {labelMap[status]}
      </Text>
    </Box>
  );
}

const styles = StyleSheet.create({
  badge: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    alignSelf: 'flex-start',
  },
  label: {
    fontSize: 11,
    fontWeight: '600',
    textTransform: 'uppercase',
  },
});
